module.exports = __webpack_public_path__ + "img/w3_circle_reload_light.14184c32.png";